import React from 'react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styles from './HeroPromoImage.module.css';
import { ContentCardBase } from "../ContentCardBase";
import * as brazeActions from '../../../../../redux/actions/braze';
import * as elementsActions from "../../../../../redux/actions/elements";
import * as contentCardConstants from "../../../../../shared/constants/contentCards";
import elementConstant from "../../../../../shared/constants/element";
import MOBILE_SIZE from '../../../../../shared/constants/size';

class HeroPromoImage extends ContentCardBase {
  constructor(props) {
    super(props);
    this.categoryElement = React.createRef();
    this.state = {
      animateClass: styles.animate,
    };
  }

  componentDidMount() {
    this.animateTimeout = setTimeout(() => {
      this.setState({ animateClass: styles.animateActive });
    }, 100);
  }

  componentWillUnmount() {
    clearTimeout(this.animateTimeout);
  }

  redirectTo = (cardData) => {
    const { location, setHeroContentCardData, openDeliveryWidget } = this.props;
    const url = cardData?.url;

    if (!url) {
      return;
    }

    if (location?.pathname !== '/' || url.startsWith(contentCardConstants.EXTERNAL_URL_PREFIX)) {
      this.handleClick(cardData);
    } else {
      this.recordClick(cardData);
      setHeroContentCardData({
        contentCardHandleClick: this.handleDeferredClick,
        contentCardData: cardData
      });
      if (openDeliveryWidget) openDeliveryWidget();
    }
  };

  handleDeepLink = (anchor) => {
    const { setProductCategory } = this.props;
    const element = document.getElementById(anchor);
    setProductCategory(anchor);

    let scrollDelta = this.categoryElement.current
      ? this.categoryElement.current.getBoundingClientRect().height
      : elementConstant.scrollDeltaDefaultHeight;

    scrollDelta = window.innerWidth > MOBILE_SIZE
      ? scrollDelta
      : elementConstant.scrollDeltaDefault;

    const yPos = element ? element.offsetTop - scrollDelta : null;
    if (yPos !== null) {
      window.scrollTo({ top: yPos, left: 0, behavior: 'smooth' });
    }
  };

  render() {
    const { cardData } = this.props;
    const { imageUrl, url, extras } = cardData;
    const { desktopImageUrl, mobileImageUrl } = extras;
    const { animateClass } = this.state;

    return (
      // eslint-disable-next-line
      <div
        className={`${styles.templateContainer} ${animateClass} ${url ? "cursor-pointer" : ""}`}
        style={{ backgroundImage: `url(${imageUrl})` }}
        role={url ? "button" : "presentation"}
        tabIndex={url ? 0 : undefined} // eslint-disable-line
        onClick={url ? () => this.redirectTo(cardData) : undefined}
        onKeyDown={url ? (e) => {
          if ((e.key === 'Enter' || e.key === ' ') && url) {
            this.redirectTo(cardData);
          }
        } : undefined}
        aria-label={url ? "Click to navigate to content" : undefined}
      >
        <div className={styles.row}>
          <picture>
            <source media="(max-width:768px)" srcSet={mobileImageUrl} />
            <img src={desktopImageUrl} className={styles.foregroundImage} alt={cardData.title || "Promotional content"} />
          </picture>
        </div>
      </div>
    );
  }
}

HeroPromoImage.propTypes = {
  cardData: PropTypes.shape({
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    url: PropTypes.string,
    extras: PropTypes.shape({
      template: PropTypes.string,
      desktopImageUrl: PropTypes.string,
      mobileImageUrl: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({}),
  openDeliveryWidget: PropTypes.func,
  setProductCategory: PropTypes.func.isRequired,
  setHeroContentCardData: PropTypes.func.isRequired,
};

export const mapDispatchToProps = (dispatch) => ({
  contentCardSession: (value) => dispatch(brazeActions.contentCardSession(value)),
  setProductCategory: (value) => dispatch(elementsActions.setProductCategory(value)),
  setHeroContentCardData: (value) => dispatch(elementsActions.setHeroContentCardData(value)),
});

export default withRouter(connect(null, mapDispatchToProps)(HeroPromoImage));
